<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="訂單編號" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="orderno">
              <a-input v-model="model.orderno" placeholder="请输入訂單編號"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="供應商" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="supplier">
              <a-input v-model="model.supplier" placeholder="请输入供應商"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="商品編碼" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="productId">
              <a-input v-model="model.productId" placeholder="请输入商品ID"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="商品名稱" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="productName">
              <a-input v-model="model.productName" placeholder="请输入商品名稱"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="商品數量" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="prodnum">
              <a-input-number v-model="model.prodnum" placeholder="请输入商品數量" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="商品單價" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="price">
              <a-input-number v-model="model.price" placeholder="请输入商品單價" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="點數" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="points">
              <a-input-number v-model="model.points" placeholder="请输入點數" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="配送日期" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="deliverTitle">
              <a-input v-model="model.deliverTitle" placeholder="请输入配送日期" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="員工工號" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="empId">
              <a-input v-model="model.empId" placeholder="请输入員工工號"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="員工姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="empName">
              <a-input v-model="model.empName" placeholder="请输入員工姓名"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="所屬法人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="empCompany">
              <a-input v-model="model.empCompany" placeholder="请输入所屬法人"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="付費法人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="payingLegalPerson">
              <a-input v-model="model.payingLegalPerson" placeholder="请输入付費法人"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="收件人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="recipient">
              <a-input v-model="model.recipient" placeholder="请输入收件人"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="收件人手機號" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="empMobile">
              <a-input v-model="model.empMobile" placeholder="请输入收件人手機號"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="收件人固話" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="empPhone">
              <a-input v-model="model.empPhone" placeholder="请输入收件人固話"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="郵箱地址" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="empEmail">
              <a-input v-model="model.empEmail" placeholder="请输入郵箱地址"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="收件地址" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="empAddress">
              <a-input v-model="model.empAddress" placeholder="请输入收件地址"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="是否寄收據" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sendReceipt">
              <a-input v-model="model.sendReceipt"   ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="捐款人證件號" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="code">
              <a-input v-model="model.code"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="捐款人生日" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="birthdayValue">
              <a-input v-model="model.birthdayValue"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="訂單備註" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="noteMessage">
              <a-input v-model="model.noteMessage" placeholder="请输入訂單備註"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="是否代收" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="adminCollect">
              <a-input v-model="model.adminCollect_dictText" placeholder="请输入是否代收"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="活動編碼" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="app">
              <a-input v-model="model.app" placeholder="请输入活動編碼"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="活動名稱" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="appName">
              <a-input v-model="model.appName" placeholder="请输入活動名稱"  ></a-input>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item label="運單公司" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="logisticsCompany">
              <a-input v-model="model.logisticsCompany" placeholder="请输入運單公司"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="運單單號" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="logisticsNo">
              <a-input v-model="model.logisticsNo" placeholder="请输入運單單號"  ></a-input>
            </a-form-model-item>
          </a-col> -->
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'ViewOrderUserDetailForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        url: {
          queryById: "/gift/plat/vieworderuserdetail/"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>
